import { Flex, Text } from "styles/utility-components";

import Button from "components/ui/button/Button";
import Modal from "components/ui/modal/Modal";
import { ProviderType } from "./types";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  source: ProviderType | null;
};
export default function ProcessingModal({ open, onOpenChange, source }: Props): JSX.Element {
  return (
    <Modal open={open} onOpenChange={onOpenChange} padding={24} maxWidth="400px">
      <Flex column gap={16}>
        <Flex column gap={8}>
          <Text h2>Making connection...</Text>
          <Text color="sysTextSecondary">
            Files and folders will be available in your content library once we have processed them.
            Processing time can depend on the size and number of files.
          </Text>
        </Flex>
        <Flex justifyContent="flex-end">
          <Button
            as="a"
            buttonType="secondary"
            to="/content-library/$provider"
            params={{ provider: source ?? "uploads" }}
          >
            Go to content library
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}
